import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { HomeComponent } from "./home.component";
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
    declarations: [
        HomeComponent,
    ],
    imports: [
        CommonModule,
        MatTooltipModule,
    ]
})
export class HomeModule {}
